export default __webpack_public_path__ + "newsela-logo.png";